module.exports = __webpack_public_path__ + "media/images/icons/icn_052-6a51198acc5e39eab31dadef25c23212.svg";